import { render, staticRenderFns } from "./PnetMessageListSideMenu.vue?vue&type=template&id=33b6a5af&scoped=true"
import script from "./PnetMessageListSideMenu.vue?vue&type=script&lang=js"
export * from "./PnetMessageListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PnetMessageListSideMenu.vue?vue&type=style&index=0&id=33b6a5af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6a5af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b6a5af')) {
      api.createRecord('33b6a5af', component.options)
    } else {
      api.reload('33b6a5af', component.options)
    }
    module.hot.accept("./PnetMessageListSideMenu.vue?vue&type=template&id=33b6a5af&scoped=true", function () {
      api.rerender('33b6a5af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pnetmessage/PnetMessageListSideMenu.vue"
export default component.exports